import { render, staticRenderFns } from "./PubbleButton.vue?vue&type=template&id=f89c57c4&scoped=true&"
import script from "./PubbleButton.vue?vue&type=script&lang=js&"
export * from "./PubbleButton.vue?vue&type=script&lang=js&"
import style0 from "./PubbleButton.vue?vue&type=style&index=0&id=f89c57c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89c57c4",
  null
  
)

export default component.exports